import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isEmpty } from 'dpl/shared/utils/object';
import Icon from 'dpl/common/components/Icon';
import Input from 'dpl/form/components/Input';
import LoadingWrapper from 'dpl/components/LoadingWrapper';

import StripeChargeModalFooter from './StripeChargeModalFooter';

export default function StripeChargeModalAccountDataStep({
  onSubmitSuccess,
  handleFormSubmission,
  isFormSubmitting,
  formErrors,
  buyerProfileData
}) {
  const requireEmail = !buyerProfileData.value.buyer_profile.user_attributes.id;

  return (
    <div className="StripeChargeModalAccountDataStep">
      <LoadingWrapper isLoading={!buyerProfileData.meta.isSuccess}>
        <div className="pt10 pb8 ph6 ph20-md">
          <p className="fw-medium f2 mb4">Enter your information</p>
          <div className="ba br1 b--light-gray ph4 pv4 mb6">
            <div>
              <div className="row slim-gutters mb5">
                <div className="col-6">
                  <Input
                    label="First Name"
                    type="text"
                    name="user_attributes.first_name"
                  />
                </div>
                <div className="col-6">
                  <Input
                    label="Last Name"
                    type="text"
                    name="user_attributes.last_name"
                  />
                </div>
              </div>
              {requireEmail && (
                <div className="mb5">
                  <Input
                    label="Email"
                    type="text"
                    name="user_attributes.email"
                    displayErrors={
                      CONFIG.isTest && formErrors['user_attributes.email']
                    }
                  />
                </div>
              )}
            </div>
          </div>
          <button
            disabled={isFormSubmitting || !isEmpty(formErrors)}
            type="button"
            className={classnames(
              'button button--primary button--large w-100 flex items-center fw-medium',
              {
                'button--loading': isFormSubmitting
              }
            )}
            onClick={() => {
              handleFormSubmission().then(
                ({ response }) => response.ok && onSubmitSuccess()
              );
            }}
          >
            <span className="center">Continue to payment</span>
            <Icon name="lined-arrow-right" />
          </button>
          <StripeChargeModalFooter />
        </div>
      </LoadingWrapper>
    </div>
  );
}

StripeChargeModalAccountDataStep.propTypes = {
  handleFormSubmission: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  isFormSubmitting: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formErrors: PropTypes.object.isRequired,
  availableStatesData: PropTypes.shape({
    value: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      data: PropTypes.array.isRequired
    }).isRequired
  }).isRequired,
  buyerProfileData: PropTypes.shape({
    meta: PropTypes.shape({
      isSuccess: PropTypes.bool
    }),
    value: PropTypes.shape({
      buyer_profile: PropTypes.shape({
        user_attributes: PropTypes.shape({
          claimed: PropTypes.bool.isRequired,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        }).isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};
